import { Base64 } from 'js-base64'

export default class ModifyEmailParam {
  constructor ({ identity, appCode, appServiceCode, verifyCode }, phone, newEmail, id) {
    this.id = id
    this.phone = phone;
    this.email = newEmail;
    this.identity = Base64.encode(identity);
    this.serviceCode = Base64.encode(appServiceCode);
    this.vCode = Base64.encode(verifyCode);
  }
}
